import React from 'react'
import styled from 'styled-components'
import { useTable } from 'react-table'
import {FormattedMessage} from "react-intl";

const Styles = styled.div`
  

  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI\\
  console.log('display data')
 
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  return (
    <div className="projectTablewrapper" >
      <table {...getTableProps()} >
      <thead>
      {headerGroups.map(headerGroup => (
        <tr {...headerGroup.getHeaderGroupProps()}>
          {headerGroup.headers.map(column => (
            <th {...column.getHeaderProps()} style={{textAlign: 'center'}}>{column.render('Header')}</th>
          ))}
        </tr>
      ))}
      </thead>
      <tbody {...getTableBodyProps()} style={{alignContent : "left"}}>
      {rows.map((row, i) => {
        prepareRow(row)
        return (
          <tr {...row.getRowProps()}>
            {row.cells.map(cell => {
              return <td className="one-long-line"  {...cell.getCellProps()}>{cell.render('Cell')}</td>
            })}
          </tr>
        )
      })}
      </tbody>
    </table>

    
    </div>
  )
}

function App(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Source',
        accessor: 'src', // accessor is the "key" in the data
      },
      {
        Header: 'Data Type',
        accessor: 'source_data_type', // accessor is the "key" in the data
      },
      {
        Header: 'Target',
        accessor: 'tgt', // accessor is the "key" in the data
      },
      {
        Header: 'Data Type',
        accessor: 'target_data_type', // accessor is the "key" in the data
      },
      {
        Header: 'Mapping Rule',
        accessor: 'rule_expression',
      }
    ],
    []
  );

  // const data2 = React.useMemo(() => makeData(20), [])
    
    console.log('test mydata')
    console.log(props.children)
    const testData = [{"source":"Sample","sourcedatatype":"string", "target":"Sample target","targetdatatype":"sample datatype","mappingrule":"rule"}]
  return (
    <Styles>
      <Table  columns={columns} data={props.children} />
      
    </Styles>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/components/views/Assesment/table.js